export default __webpack_public_path__ + "static/media/train_ravenna_bridge.18c43d57.jpg";